'use client'

import { Button, Label } from '@chain-zen/ui'

import { useWorkspaceSetup } from '../../contexts/setup-workspace-context'
import { useAuth } from '../../hooks/use-auth'
import { useSetupWorkspaceModal } from '../../stores/setup-workspace-modal-store'
import { SetupWorkspaceLayout } from './setup-workspace-layout'

/**
 * This component is used to confirm the workspace and finish the setup process.
 */
export const ConfirmationStep = ({ onClose }: { onClose?: () => void }) => {
  const { handleSetWorkspaceID, setWorkspace } = useSetupWorkspaceModal()
  const { setStep } = useWorkspaceSetup()

  const { refetchWorkspaces } = useAuth()

  const handleClose = () => {
    onClose?.()
    setStep(2) // Setting the step to 2 will trigger the previous step in the setup process which is the SelectMCOrDOTType component.
    refetchWorkspaces()
    handleSetWorkspaceID(null)
    setWorkspace(null)
  }
  return (
    <SetupWorkspaceLayout title="🎉 You are all set!">
      <Label className="font-light">You have been verified!</Label>
      <Button className="w-full mt-4" onClick={handleClose}>
        Finish
      </Button>
    </SetupWorkspaceLayout>
  )
}
